/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:no-non-null-assertion

import { PreconstructionBuildTimesDto } from '@gh/builder-shared-data';
import { clone } from 'lodash';

export type PreconstructionBuildTimes = PreconstructionBuildTimesDto;
export type PreconstructionBuildTimesListItem = {
  preconstructionJobNumber: string;
  preconstructionJobTime: any;
  buildJobNumber?: string;
  buildJobTime?: any;
};

export const preconstructionBuildTimesFromDto = (dto: PreconstructionBuildTimesDto):
  PreconstructionBuildTimesListItem[] => {
  const maxItems = Math.max(dto.preconstructionJobs.length, dto.buildJobs.length);
  const emptyRow: PreconstructionBuildTimesListItem = {
    preconstructionJobNumber: '',
    preconstructionJobTime: '',
    buildJobNumber: '',
    buildJobTime: '',
  };

  return new Array(maxItems)
    .fill(emptyRow)
    .map((item: PreconstructionBuildTimesListItem, index: number) => {
      const preconstructionJob = dto.preconstructionJobs[index];
      const buildJob = dto.buildJobs[index];

      item.preconstructionJobNumber = preconstructionJob ? preconstructionJob.jobNumber : '';
      item.preconstructionJobTime = preconstructionJob ? {
        label: 1 === preconstructionJob.value ? 'lbl_week_cnt' : 'lbl_weeks_cnt',
        value: {
          count: preconstructionJob.value,
        },
      } : '';

      item.buildJobNumber = buildJob ? buildJob.jobNumber : '';
      item.buildJobTime = buildJob ? {
        label: 1 === buildJob.value ? 'lbl_week_cnt' : 'lbl_weeks_cnt',
        value: {
          count: buildJob.value,
        },
      } : '';

      return clone(item);
    });
};
